
/**
 * @copyright 2019 @ DigiNet
 * @author rocachien
 * @create 2019/01/11 10:37
 * @update 2019/01/11 10:37
 * @file src/components/header/header.js
 */

import React from 'react';
import {connect} from "react-redux";
import {browserHistory} from "react-router";
import {bindActionCreators} from "redux";

import * as W17F2051Actions from "../../../actions/w17/W17F2051/W17F2051-actions";
import * as userActions from "../../../actions/user-actions";
import * as generalActions from "../../../actions/general-actions";
import {Column} from 'devextreme-react/data-grid';
import {Loading} from "../../common/loading/loading";
import Config from "../../../config";
import EventTracking from "../../common/tracking/event";
import notify from 'devextreme/ui/notify';

import PageContainer from "../../common/page-container/page-container";
import Combo from '../../common/dropdown/combo';
import { DateBox } from 'devextreme-react';
import _ from "lodash"
import { uploadCDN_sync as uploadFileSync } from "../../../actions/file-upload-cdn-async";
import NumberFormat from 'react-number-format';
import { Attachment, Row, Col, Label as LabelCore, Button as ButtonCore, Typography, ButtonIcon, Accordion, AccordionDetails, AccordionGroup, AccordionSummary } from 'diginet-core-ui/components';

const Label = (props) => <LabelCore hoverTooltip type={"h4"} {...props} />;
const Button = (props) => <ButtonCore size={"small"} labelProps={{ style: { color: 'initial' } }} {...props} />;

class W17F2051Page extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state ={
            loadingNewKey:false,
            loading:false,
            iPermission:0,
            allowAddMore:false,
            attachmentLoading: false,
            attachmentSignLoading: false,
            collapse:{
                1:true,
              
            },
            masterInputData:{

            },
            anaMaster: [],
            AdditionalMaster:[],
            dataOldAttachments:[],
            dataOldSignature: [],
            dataCboSalePerson: [],
        }
        this.attachments = [];
        this.attachmentSign = [];
        this.deletedFile = [];
        this.deletedSign = [];
    }
    async loadPermission() {
        await this.props.userActions.getPermission(Config.profile.UserID, "W17F2050",(iPer)=>{
            this.setState({iPermission: iPer});
        });
    }
    componentDidMount() {
        this.loadPermission()
        const {mode} = this.getInfo()
        // load cb
        this.props.W17F2051Actions.getCboCategoryType({}, (error,data) =>{
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                this.setState({ 
                    masterInputData: {
                        ...this.state.masterInputData,
                        S1: data.length > 0 ? data[0].CategoryID : ""
                    }
                });
            }
        })

        this.loadCboSalePerson();
        this.props.W17F2051Actions.getCboGender()

        this.props.W17F2051Actions.getAnaMaster({},(error,data) =>{
            if (error || !data) {
                return
            }
            let categories =_.groupBy(data,"AnaCategoryID")
            let anaMaster = _.map(categories,(value,AnaCategoryID) =>{
                const curAnaData = _.find(this.state.anaMaster,{AnaCategoryID}) || {}
                return {
                    ...curAnaData,
                    AnaCategoryID,
                    AnaList:value
                }
            })
           this.setState({anaMaster})

        })
        this.props.W17F2051Actions.getAnaMasterCaption({},(error,data) =>{
            if (error || !data) {
                return
            }
            const {anaMaster} = this.state
            _.forEach(data,anaCaption => {
                if (anaCaption.AnaCategoryID) {
                    let index =  anaMaster.findIndex(item =>  item.AnaCategoryID === anaCaption.AnaCategoryID)
                    if (index !== -1) {
                        anaMaster[index] = {
                            ...anaMaster[index],
                            ...anaCaption
                        }
                    }else{
                        anaMaster.push(anaCaption)
                    }
                }
            })
            this.setState({anaMaster})

        })

        this.props.W17F2051Actions.getAdditionalMasterCaption({},(error,data) =>{
            if (error || !data) {
                return
            }
            const AdditionalMaster =[]
            _.forEach(data,item => {
                item.DataType =_.startsWith(item.DataID,"Num",4) 
                                ?"Num"
                                :_.startsWith(item.DataID,"Date",4)?"Date":"String"
                AdditionalMaster.push(item)
            })
            this.setState({AdditionalMaster})

        })
        if (mode === "add") {
            //this.getNewKey()
        }
        if (mode === "view" || mode === "edit") {
            this.loadFormMaster()
            this.loadAttachments();
            this.loadSignature();
        }
    }

    // load cbo SalePerson
    loadCboSalePerson = () => {
         const { ObjectID = '' } = this.getInfo() || {};
        const params = {
            ObjectID
        };
        this.props.W17F2051Actions.loadCboSalePerson(params, (error,data) =>{
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                this.setState({ 
                    dataCboSalePerson: data
                });
            }
        })
    }

    loadAttachments = () => {
        const { ObjectID = '' } = this.getInfo() || {};
        const params = {
            ObjectID
        };
        this.setState({ attachmentLoading: true });
        this.props.W17F2051Actions.loadAttachments(params, (error, data) => {
            this.setState({ attachmentLoading: false });
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                this.setState({ dataOldAttachments: data });
            }
        })
    };

     loadSignature = () => {
        const { ObjectID = '' } = this.getInfo() || {};
        const params = {
            ObjectID
        };
        this.setState({ signatureLoading: true });
        this.props.W17F2051Actions.loadSignature(params, (error, data) => {
            this.setState({ signatureLoading: false });
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                this.setState({ dataOldSignature: data });
            }
        })
    };


    getInfo =() => {
        const {location} = this.props
        const url = new window.URLSearchParams(window.location.search);
        let state =  {}
        const keys = [...url.keys()]
        if (keys.length) {

            for (let key of keys) {
                state[key] = url.get(key)
            }
        }
        state = {
            ...state,
            ...( (location && location.state) || {})
        }
        state.mode = state.mode || "add"
        return state
    }
    loadFormMaster = () =>{
        const {ObjectID} = this.getInfo()
        const params = {
            Language: Config.language || '84',
            FormID: 'W17F2051',
            CodeID:ObjectID
        }
        this.setState({loading:true})
        this.props.W17F2051Actions.getForm(params,(error, data) => {

            if (error || !data) {
                let message = (error && error.message) || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show('INFO', message);
                this.setState({loading: false});
                return false;
            }
            const  masterInputData =_.get(data,"0",{})
            this.state.anaMaster.map(ana  => {
                if (ana.AnaCategoryID && ana.AnaList) {
                    masterInputData[`${ana.AnaCategoryID}Name`] = _.get(_.find(ana.AnaList,{AnaID:masterInputData[`${ana.AnaCategoryID}ID`]}),"AnaName","")
                }
                return false
            })
            this.setState({masterInputData,loading: false})
        })
    }
    loadNewKey = (data) =>{

        const S1 = data || _.get(this.state,"masterInputData.S1","")
        if (!S1) {
            return
        }
        const params = {
            Language: Config.language || '84',
            CodeID: "",
            S1
        }
        this.setState({loadingNewKey: true});
        this.props.W17F2051Actions.getNewKey(params,(error,data) => {

            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show('INFO', message);
                this.setState({loadingNewKey: false});
                return false;
            }
            if (!data) {
                let message = Config.lang("Loi_chua_xac_dinh");
                Config.popup.show('INFO', message);
                this.setState({loadingNewKey: false});
                return false;
            }
            this.setState({loadingNewKey: false,masterInputData:{...this.state.masterInputData,ObjectID: data.NewKey}});
        })

    }
    // event
    onChangeMasterInputData =(e) =>{
        const {name,value} = e.target
        const newMasterInputData = {...this.state.masterInputData}
        switch (name) {

            default:
                newMasterInputData[name] = value
                this.setState({masterInputData:newMasterInputData})
        }

    }
    onChangeMasterInputDataObject =(obj ={} ) =>{
        const newMasterInputData = {...this.state.masterInputData,...obj}
        this.setState({masterInputData:newMasterInputData})

    }
    onClickEdit = () =>{
        let params = {
            Language: Config.language || '84',
            CodeID: _.get(this.state,"masterInputData.ObjectID")
        }
        this.setState({loading:true})
        return this.props.W17F2051Actions.checkEdit(params,async (error,data) => {
            if (error || !data) {
                let message = (error && error.message) || Config.lang("Loi_chua_xac_dinh");
                this.setState({ loading: false});
                return Config.popup.show('INFO', message);
            }
            if (data.Status === 0) {
                this.setState({ loading: false});
                this.onChangeLocationState({
                    mode: "edit",
                })
            }else{
                return Config.popup.show('INFO', data.Message)
            }

        })

    }
    onClickAddMore = (e) =>{
        this.setState({masterInputData:{},allowAddMore:false})
        this.onChangeLocationState({mode:"add",ObjectID:null})
    }
    onClickSave = () =>{
        const {mode} = this.getInfo()
        let params = this.getSaveParams()
        params.Mode = mode === "add" ? "Save" : "SaveEdit"
        let error = this.checkSaveParams(params)
        if (error) {
            return Config.popup.show('INFO', error);
        }
        this.onSaveAttachment(); // Luu dinh kem
        this.onSave(params,mode,()=>{
            this.onChangeLocationState({
                ObjectID: params.ObjectID,
                mode: "view",
            })
            this.loadFormMaster();
        })
    }
    onChangeLocationState =(state ={}) =>{
        const newLocation = this.props.location || {}
        newLocation.state = newLocation.state ?{...newLocation.state,...state} :state
        browserHistory.replace(newLocation)
    }
    onClickGoBack = (e) =>{
        const {formCall,formCallState} = this.getInfo()
        if (formCall) {
            browserHistory.push({pathname: Config.env.url + `/${formCall}`, state:formCallState});
        }else{
            browserHistory.goBack();
        }
    }
    onSave =(params,mode,cb) => {
        this.setState({loading:true})
        return this.props.W17F2051Actions.save(params,async (error,data) => {
            if (error || !data) {
                let message = (error && error.message) || Config.lang("Loi_chua_xac_dinh");
                this.setState({ loading: false });
                return Config.popup.show('INFO', message);
            }
            if (data.Status === 0) {
                notify(Config.lang("Luu_thanh_cong"),"success", 2000)
                this.setState({ loading: false,allowAddMore: mode === "add"});

                cb && cb()
            }else{
                this.setState({ loading: false});
                return Config.popup.show('INFO', data.Message)
            }

        })

    }
    //handle 
    checkSaveParams =(params) =>{
        if (!params.S1) {
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${Config.lang("Su_dung_phan_loai")}!`
        }
        if (!params.ObjectNameU) {
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${Config.lang("Ten")}!`
        }
        if (!params.Gender) {
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${Config.lang("Gioi_tinh")}!`
        }
        if (!params.IDCardNo) {
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${Config.lang("So_CCCD_/_CMND")}!`
        }
        if (!params.IDCardIssueDate) {
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${Config.lang("Ngay_cap_CMND")}!`
        }
        if (!params.IDCardIssuePlaceU) {
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${Config.lang("Noi_cap")}!`
        }
        if (!params.TelNo) {
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${Config.lang("So_dien_thoai")}!`
        }else{
            let rgx = /^\d{10,}$/
            if ( !rgx.test(params.TelNo)) {
                return `${Config.lang("So_dien_thoai_khong_hop_le")}!`
            }

        }
        if (!params.AddressLine1U) {
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${Config.lang("Dia_chi_thuong_tru")}!`
        }
        if (!params.ObjectAddressU) {
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${Config.lang("Dia_chi_lien_he")}!`
        }
        if (!params?.O08ID) {
            const anaCategoryNameU = this.state.anaMaster?.find(x => x?.AnaCategoryID === 'O08')?.AnaCategoryNameU || '';
            return `${Config.lang("Ban_chua_nhap_gia_tri")}: ${anaCategoryNameU}!`
        }
        return false
    }
    getSaveParams = () =>{
        const {masterInputData,anaMaster,AdditionalMaster} = this.state
        let anaData ={}
        let additionalData ={}
        anaMaster.map(ana =>{
            if (ana.AnaCategoryID) {
                anaData[`${ana.AnaCategoryID}ID`] = masterInputData[`${ana.AnaCategoryID}ID`] || null
            }
            return false
        })
        AdditionalMaster.map(item =>{
            if (item.DataID) {
                additionalData[`${item.DataID}`] = masterInputData[`${item.DataID}`] || null
            }
            return false
        })
        return {
            Language: Config.language || '84',
            CodeID: masterInputData.ObjectID || "",
            S1: masterInputData.S1 || "",
            ObjectTypeID: masterInputData.ObjectTypeID || "",
            ObjectID: masterInputData.ObjectID || "",
            RefInformationU: masterInputData.RefInformationU || "",
            ObjectNameU: masterInputData.ObjectNameU || "",
            BirthDate: masterInputData.BirthDate || null,
            Gender: masterInputData.Gender || "",
            IDCardNo: masterInputData.IDCardNo || "",
            IDCardIssueDate: masterInputData.IDCardIssueDate || "",
            IDCardIssuePlaceU: masterInputData.IDCardIssuePlaceU || "",
            TelNo: masterInputData.TelNo || "",
            Email: masterInputData.Email || "",
            AddressLine1U: masterInputData.AddressLine1U || "",
            ObjectAddressU: masterInputData.ObjectAddressU || "",
            BankAccountNo: masterInputData.BankAccountNo || "",
            BankBranchNameU	: masterInputData.BankBranchNameU	 || "",
            SalePersonID: masterInputData.SalePersonID || "",
            ...anaData,
            ...additionalData,
        }
    }

    onChangeAttachments = (e, mode) => {
        const { dataOldAttachments, dataOldSignature } = this.state; 
        if (mode === 0) {
            this.attachments = e.allNewAttached ? e.allNewAttached : [];
            if (e.removedAttached && e.removedAttached.length > 0) {
                this.deletedFile = [...e.removedAttached];
                const _arrRemove = this.deletedFile.map(d => d.AttachmentID);
                this.setState({
                    dataOldAttachments: dataOldAttachments.filter(att => {
                        return _arrRemove.indexOf(att.AttachmentID) < 0;
                    })
                });
            }
        } else if (mode === 1) {
            this.attachmentSign = e.allNewAttached ? e.allNewAttached : [];
            if (e.removedAttached && e.removedAttached.length > 0) {
                this.deletedSign = [...e.removedAttached];
                const _arrRemove = this.deletedSign.map(d => d.AttachmentID);
                this.setState({
                    dataOldSignature: dataOldSignature.filter(att => {
                        return _arrRemove.indexOf(att.AttachmentID) < 0;
                    })
                });
            }
        }
    };

    _uploadFile = (files) => {
        const cdnToken = Config.decryptData(Config.getLocalStorage('CDN_TOKEN'));
        return uploadFileSync(files, 'multiple', cdnToken);
    };

    _getAttachments = (file, mode) => {
        let arrAttachment = [];
        const dataFile = file?.data?.paths || [];
        const listAttachments = Config.helpers.getFileInfomations(dataFile);
        const { dataOldAttachments, dataOldSignature } = this.state;
        listAttachments.forEach((att) => {
            arrAttachment.push({
                URL: att.url ? att.url : "",
                FileName: att.fileName ? att.fileName : "",
                FileSize: att.fileSize ? att.fileSize : "",
                FileExt: att.fileName ? att.fileName.split(".").pop() : "",
            });
        });
        if (mode === 0) {
            if (dataOldAttachments && dataOldAttachments.length > 0) arrAttachment = dataOldAttachments.concat(arrAttachment);
        } else {
            if (dataOldSignature && dataOldSignature.length > 0) arrAttachment = dataOldSignature.concat(arrAttachment);
        }
        return arrAttachment;
    };

    onRemoveAttachment = (AttachmentID = '', TableName = '') => {
        const { ObjectID = '' } = this.state?.masterInputData || {};
        const params = {
            AttachmentID,
            KeyID: ObjectID,
            Key2ID: '',
            TableName
        };
        const loadingName = TableName === 'W17F2051_Attached' ? 'attachmentLoading' : 'attachmentSignLoading';
        this.setState({ [loadingName]: true });
        this.props.generalActions.addAttachments(params, (error) => {
            this.setState({ [loadingName]: false });
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            }
        });
    };

    onSaveAttachment = async () => {
        const { ObjectID = '' } = this.state?.masterInputData || {};
        const dataResUploadFile = await this._uploadFile(this.attachments, true);
        const dataResUploadFileSign = await this._uploadFile(this.attachmentSign, true);
        const arrAttachment = this._getAttachments(dataResUploadFile, 0);
        const arrSign = this._getAttachments(dataResUploadFileSign, 1);
        const params = {
            KeyID: ObjectID,
            Key2ID: '',
            Sequence: 0,
        };
        const paramAtt = {
            ...params,
            TableName: 'W17F2051_Attached',
            arrAttachment
        };
        const paramSig = {
            ...params,
            TableName: 'W17F2051_Signature',
            arrAttachment: arrSign
        };
        this.setState({ attachmentLoading: true, attachmentSignLoading: true });
        this.props.generalActions.addAttachments(paramAtt, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
            } else if (data) this.loadAttachments();
        });
        this.props.generalActions.addAttachments(paramSig, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
            } else if (data) this.loadSignature();
        });
        this.setState({ attachmentLoading: false, attachmentSignLoading: false });
    };

    render() {
        const {mode} = this.getInfo()
        const ViewMode = mode === "view"
        const AddMode = mode === "add"
        const EditMode = mode === "edit"
        const {cboCategoryType,cboGender} = this.props
        const {iPermission,allowAddMore,masterInputData,loadingNewKey,anaMaster,AdditionalMaster,loading, dataOldAttachments, dataOldSignature, dataCboSalePerson} = this.state
        
        return (
            <PageContainer>
                {Config && Config.profile &&
                <EventTracking category={"TRACKING_USER"} action={"W17F1025"} label={Config.profile.UserID}/>}
                {
                    loading && <Loading/>
                }
                <Row>
                    <Col xs={12}><Typography color={"info"} type={"h4"}>{Config.lang("Cong_tac_vien")}</Typography></Col>
                    <Col md={12} sm={12} xs={12} lg={12}>
                        <Button
                            size={"small"}
                            color={'warning'}
                            startIcon={"Back"}
                            label={Config.lang('Quay_lai')}
                            labelProps={{ style: { color: 'initial' } }}
                            onClick={this.onClickGoBack}
                        />
                        <Button
                            color={'info'}
                            startIcon={"Edit"}
                            className={`mgl1x ${iPermission >= 3 ? "" : "isDisabled"} ${ViewMode ? "" : "hide"}`}
                            label={Config.lang('Sua')}
                            onClick={() => {
                                if (iPermission >= 3) this.onClickEdit();
                            }}
                        />
                        <Button
                            size={"small"}
                            color={'info'}
                            startIcon={"Save"}
                            label={Config.lang('Luu')}
                            labelProps={{ style: { color: 'initial' } }}
                            className={`mgl1x ${iPermission >= 2 ? "" : "isDisabled"} ${(AddMode || EditMode) ? "" : "hide"}`}
                            onClick={() => {
                                if (iPermission >= 2) {
                                    this.onClickSave()
                                }
                            }}
                        />
                        <Button
                            size={"small"}
                            color={'info'}
                            startIcon={"Add"}
                            label={Config.lang('Nhap_tiep')}
                            labelProps={{ style: { color: 'initial' } }}
                            className={`mgl1x ${iPermission >= 2 ? "" : "isDisabled"} ${(allowAddMore) ? "" : "hide"}`}
                            onClick={() => {
                                if (iPermission >= 2) {
                                    this.onClickAddMore()
                                }
                            }}
                        />
                    </Col>
                    <Col xs={12} className={'mgh6x'}>
                        <Row>
                            <Col xs={12}>
                                <Row>
                                    <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                        <Label required>{Config.lang("Su_dung_phan_loai")}</Label>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4}>
                                        <Combo
                                            showClearButton={true}
                                            showHeader={false}
                                            dataSource={cboCategoryType}
                                            placeholder={''}
                                            value={masterInputData.S1}
                                            valueExpr="CategoryID"
                                            displayExpr="Description"
                                            onActionWhenSelectChange={data => {

                                                this.onChangeMasterInputDataObject({
                                                    S1: data ? data.CategoryID : "",
                                                })
                                                AddMode && this.loadNewKey(data ? data.CategoryID : "")
                                            }}
                                            disabled={ViewMode || EditMode}
                                        >
                                            <Column dataField={'CategoryID'} caption="" width={'150px'}
                                                dataType={'string'} />
                                            <Column dataField={'Description'} caption="" width={'150px'}
                                                dataType={'string'} />
                                        </Combo>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                <div className={"display_row align-center"}>
                                    <Label required>{Config.lang("Ma")}</Label>
                                    {AddMode && <ButtonIcon
                                        circular
                                        name={"SyncHorizontal"}
                                        size={"medium"}
                                        color={"info"}
                                        viewType={"ghost"}
                                        className={"mgl4x"}
                                        loading={loadingNewKey}
                                        onClick={() => this.loadNewKey()} />}
                                </div>
                            </Col>
                            <Col xs={6} sm={4} md={4} lg={4}>
                                <input className={'form-control'}
                                    name="CompanyID"
                                    onChange={this.onChangeMasterInputData}
                                    value={masterInputData.ObjectID || ""}
                                    disabled
                                />
                            </Col>
                            <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                <Label>{Config.lang("Nhan_su_phu_trach")}</Label>
                            </Col>
                            <Col xs={6} sm={4} md={4} lg={4}>
                                <Combo
                                    showClearButton={true}
                                    showHeader={false}
                                    dataSource={dataCboSalePerson}
                                    placeholder={''}
                                    value={masterInputData.SalePersonID}
                                    valueExpr="SalePersonID"
                                    displayExpr="SalePersonName"
                                    onActionWhenSelectChange={data => {
                                        this.onChangeMasterInputDataObject({
                                            SalePersonID: data ? data.SalePersonID : "",
                                        })
                                    }}
                                    disabled={ViewMode || EditMode}
                                >
                                    <Column dataField={'SalePersonID'} caption="" width={'150px'}
                                        dataType={'string'} />
                                </Combo>
                            </Col>
                            {/* <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                <Label>{Config.lang("Ten_tat")}</Label>
                            </Col>
                            <Col xs={6} sm={4} md={4} lg={4}>
                                <input className={'form-control'}
                                    name="RefInformationU"
                                    onChange={this.onChangeMasterInputData}
                                    value={masterInputData.RefInformationU || ""}
                                    disabled={ViewMode}
                                />
                            </Col> */}
                            <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                <Label required>{Config.lang("Ten")}</Label>
                            </Col>
                            <Col md={10} sm={10} xs={6} lg={10}>
                                <input className={'form-control'}
                                    name="ObjectNameU"
                                    onChange={this.onChangeMasterInputData}
                                    value={masterInputData.ObjectNameU || ""}
                                    disabled={ViewMode}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12}>
                        <AccordionGroup collapseOther={false}>
                            {/* group 1 */}
                            <Accordion expand>
                                <AccordionSummary>
                                    {Config.lang("Thong_tin_ca_nhan")}
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Row>
                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label>{Config.lang("Ngay_sinh")}</Label>
                                        </Col>
                                        <Col xs={6} sm={4} md={4} lg={4}>
                                            <DateBox
                                                name="BirthDate"
                                                width={"100%"}
                                                dateSerializationFormat={'yyyy-MM-dd HH:mm:ss'}
                                                placeholder={Config.lang("Ngay_sinh")}
                                                openOnFieldClick={true}
                                                useMaskBehavior={true}
                                                showClearButton={true}
                                                type={'date'}
                                                pickerType={"calendar"}
                                                showAnalogClock={false}
                                                displayFormat={'dd/MM/y'}
                                                value={masterInputData.BirthDate}
                                                onValueChanged={e => this.onChangeMasterInputDataObject({ BirthDate: e.value })}
                                                disabled={ViewMode}
                                            />
                                        </Col>
                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label required>{Config.lang("Gioi_tinh")}</Label>
                                        </Col>
                                        <Col xs={6} sm={4} md={4} lg={4}>
                                            <Combo
                                                showClearButton={true}
                                                showHeader={false}
                                                dataSource={cboGender}
                                                placeholder={''}
                                                value={masterInputData.Gender}
                                                valueExpr="GenderID"
                                                displayExpr="GenderName"
                                                onActionWhenSelectChange={data => {
                                                    this.onChangeMasterInputDataObject({
                                                        Gender: data ? data.GenderID : "",
                                                    })
                                                }}
                                                disabled={ViewMode}


                                            >
                                                <Column dataField={'GenderName'} caption="" width={'150px'}
                                                    dataType={'string'} />
                                            </Combo>

                                        </Col>
                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label required>{Config.lang("So_CCCD_/_CMND")}</Label>
                                        </Col>
                                        <Col xs={6} sm={4} md={4} lg={4}>
                                            <input className={'form-control'}
                                                name="IDCardNo"
                                                onChange={this.onChangeMasterInputData}
                                                value={masterInputData.IDCardNo || ""}
                                                disabled={ViewMode}
                                            /></Col>
                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label required>{Config.lang("Ngay_cap_CMND")}</Label>
                                        </Col>
                                        <Col xs={6} sm={4} md={4} lg={4}>
                                            <DateBox
                                                name="IDCardIssueDate"
                                                width={"100%"}
                                                dateSerializationFormat={'yyyy-MM-dd HH:mm:ss'}
                                                placeholder={Config.lang("Ngay_cap_CMND")}
                                                openOnFieldClick={true}
                                                useMaskBehavior={true}
                                                showClearButton={true}

                                                type={'date'}
                                                pickerType={"calendar"}
                                                showAnalogClock={false}
                                                displayFormat={'dd/MM/y'}
                                                value={masterInputData.IDCardIssueDate}
                                                onValueChanged={e => this.onChangeMasterInputDataObject({ IDCardIssueDate: e.value || "" })}
                                                disabled={ViewMode}
                                            />
                                        </Col>
                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label required>{Config.lang("Noi_cap")}</Label>
                                        </Col>
                                        <Col md={10} sm={10} xs={6} lg={10}>
                                            <input className={'form-control'}
                                                name="IDCardIssuePlaceU"
                                                onChange={this.onChangeMasterInputData}
                                                value={masterInputData.IDCardIssuePlaceU || ""}
                                                disabled={ViewMode}
                                            />
                                        </Col>
                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label required>{Config.lang("So_dien_thoai")}</Label>
                                        </Col>
                                        <Col xs={6} sm={4} md={4} lg={4}>
                                            <input className={'form-control'}
                                                name="TelNo"
                                                onChange={this.onChangeMasterInputData}
                                                value={masterInputData.TelNo || ""}
                                                disabled={ViewMode}
                                            />
                                        </Col>

                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label>{Config.lang("Email")}</Label>
                                        </Col>
                                        <Col xs={6} sm={4} md={4} lg={4}>
                                            <input className={'form-control'}
                                                name="Email"
                                                onChange={this.onChangeMasterInputData}
                                                value={masterInputData.Email || ""}
                                                disabled={ViewMode}
                                            />
                                        </Col>

                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label required>{Config.lang("Dia_chi_thuong_tru")}</Label>
                                        </Col>
                                        <Col md={10} sm={10} xs={6} lg={10}>
                                            <input className={'form-control'}
                                                name="AddressLine1U"
                                                onChange={this.onChangeMasterInputData}
                                                value={masterInputData.AddressLine1U || ""}
                                                disabled={ViewMode}
                                            />
                                        </Col>

                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label required>{Config.lang("Dia_chi_lien_he")}</Label>
                                        </Col>
                                        <Col md={10} sm={10} xs={6} lg={10}>
                                            <input className={'form-control'}
                                                name="ObjectAddressU"
                                                onChange={this.onChangeMasterInputData}
                                                value={masterInputData.ObjectAddressU || ""}
                                                disabled={ViewMode}
                                            />
                                        </Col>

                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label>{Config.lang("So_tai_khoan")}</Label>
                                        </Col>
                                        <Col xs={6} sm={4} md={4} lg={4}>
                                            <input className={'form-control'}
                                                name="BankAccountNo"
                                                onChange={this.onChangeMasterInputData}
                                                value={masterInputData.BankAccountNo || ""}
                                                disabled={ViewMode}
                                            />
                                        </Col>
                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                            <Label>{Config.lang("Chi_nhanh_ngan_hang")}</Label>
                                        </Col>
                                        <Col xs={6} sm={4} md={4} lg={4}>
                                            <input className={'form-control'}
                                                name="BankBranchNameU"
                                                onChange={this.onChangeMasterInputData}
                                                value={masterInputData.BankBranchNameU || ""}
                                                disabled={ViewMode}
                                            />
                                        </Col>
                                        {anaMaster.map(ana => {
                                            if (ana.UseOO === 1 && ana.AnaCategoryID === "O08") {
                                                return <Col xs={12}>
                                                    <Row key={ana.AnaCategoryID}>
                                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                                            <Label required>{ana.AnaCategoryNameU}</Label>
                                                        </Col>
                                                        <Col xs={6} sm={4} md={4} lg={4}>
                                                            <Combo
                                                                showClearButton={true}
                                                                showHeader={false}
                                                                dataSource={ana.AnaList}
                                                                placeholder={''}
                                                                value={masterInputData[`${ana.AnaCategoryID}ID`]}
                                                                valueExpr="AnaID"
                                                                displayExpr="AnaID"
                                                                onActionWhenSelectChange={data => {
                                                                    this.onChangeMasterInputDataObject({
                                                                        [`${ana.AnaCategoryID}ID`]: data ? data.AnaID : "",
                                                                        [`${ana.AnaCategoryID}Name`]: data ? data.AnaName : ""
                                                                    })
                                                                }}
                                                                disabled={ViewMode}
                                                            >
                                                                <Column dataField={'AnaID'} caption="" width={'150px'}
                                                                    dataType={'string'} />
                                                                <Column dataField={'AnaName'} caption="" width={'150px'}
                                                                    dataType={'string'} />
                                                            </Combo>
                                                        </Col>
                                                        <Col xs={6} sm={2} md={2} lg={2} />
                                                        <Col xs={6} sm={4} md={4} lg={4}>
                                                            <input className={'form-control'}
                                                                value={masterInputData[ana.AnaCategoryID + "Name"] || ""}
                                                                disabled
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            }
                                            return false;
                                        })}
                                    </Row>
                                </AccordionDetails>
                            </Accordion>
                            {/* group 2 */}
                            <Accordion>
                                <AccordionSummary>
                                    {Config.lang("Thong_tin_phu")}
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Row>
                                        {anaMaster.map(ana => {
                                            if (ana.UseOO === 1 && ana.AnaCategoryID !== "O08") {
                                                return <Col xs={12}>
                                                    <Row key={ana.AnaCategoryID}>
                                                        <Col xs={6} sm={2} md={2} lg={2} verticalAlign={'center'}>
                                                            <Label>{ana.AnaCategoryNameU}</Label>
                                                        </Col>
                                                        <Col xs={6} sm={4} md={4} lg={4}>
                                                            <Combo
                                                                showClearButton={true}
                                                                showHeader={false}
                                                                dataSource={ana.AnaList}
                                                                placeholder={''}
                                                                value={masterInputData[`${ana.AnaCategoryID}ID`]}
                                                                valueExpr="AnaID"
                                                                displayExpr="AnaID"
                                                                onActionWhenSelectChange={data => {
                                                                    this.onChangeMasterInputDataObject({
                                                                        [`${ana.AnaCategoryID}ID`]: data ? data.AnaID : "",
                                                                        [`${ana.AnaCategoryID}Name`]: data ? data.AnaName : ""
                                                                    })
                                                                }}
                                                                disabled={ViewMode}
                                                            >
                                                                <Column dataField={'AnaID'} caption="" width={'150px'}
                                                                    dataType={'string'} />
                                                                <Column dataField={'AnaName'} caption="" width={'150px'}
                                                                    dataType={'string'} />
                                                            </Combo>
                                                        </Col>
                                                        <Col xs={6} sm={2} md={2} lg={2} />
                                                        <Col xs={6} sm={4} md={4} lg={4}>
                                                            <input className={'form-control'}
                                                                value={masterInputData[ana.AnaCategoryID + "Name"] || ""}
                                                                disabled
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            }
                                            return false;
                                        })}
                                    </Row>
                                </AccordionDetails>
                            </Accordion>
                            {/* group 3 */}
                            <Accordion>
                                <AccordionSummary>
                                    {Config.lang("Thong_tin_bo_sung")}
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Row>
                                        {AdditionalMaster && AdditionalMaster.map(item => {
                                            if (item.DefaultUse === 1) {
                                                return (<Col xs={12} sm={6} key={item.DataID}>
                                                    <Row>
                                                        <Col xs={6} sm={4} md={4} lg={4} verticalAlign={'center'}>
                                                            <Label>{item.Description}</Label>
                                                        </Col>
                                                        <Col xs={6} sm={8} md={8} lg={8}>
                                                            {item.DataType === "Date"
                                                                ? <DateBox
                                                                    name={item.DataID}
                                                                    width={"100%"}
                                                                    dateSerializationFormat={'yyyy-MM-dd HH:mm:ss'}
                                                                    placeholder={item.Description}
                                                                    openOnFieldClick={true}
                                                                    useMaskBehavior={true}
                                                                    showClearButton={true}
                                                                    type={'date'}
                                                                    pickerType={"calendar"}
                                                                    showAnalogClock={false}
                                                                    displayFormat={'dd/MM/y'}
                                                                    value={masterInputData[item.DataID]}
                                                                    onValueChanged={e => this.onChangeMasterInputDataObject({ [item.DataID]: e.value })}
                                                                    disabled={ViewMode}
                                                                />
                                                                : item.DataType === "Num"
                                                                    ? <NumberFormat
                                                                        className='form-control'
                                                                        decimalScale={item.DecimalNum}
                                                                        thousandSeparator={true}
                                                                        isNumericString={true}
                                                                        value={masterInputData[item.DataID] || ""}
                                                                        onValueChange={e => this.onChangeMasterInputDataObject({ [item.DataID]: e.value })}
                                                                        suffix={item.FormatData === "PERCENT" ? "%" : ""}
                                                                        disabled={ViewMode}
                                                                    />
                                                                    : <input className={'form-control'}
                                                                        name={item.DataID}
                                                                        onChange={this.onChangeMasterInputData}
                                                                        value={masterInputData[item.DataID] || ""}
                                                                        disabled={ViewMode}
                                                                    />
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Col>)
                                            }
                                            return false;
                                        })}
                                    </Row>
                                </AccordionDetails>
                            </Accordion>
                            {/* group 4 */}
                            <Accordion>
                                <AccordionSummary>
                                    {Config.lang('Dinh_kem')}
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Attachment
                                        isStripDomain
                                        readOnly={ViewMode || loading}
                                        domain={Config.getCDNPath()}
                                        data={dataOldAttachments}
                                        style={{ minHeight: 160 }}
                                        onChange={(e) => this.onChangeAttachments(e, 0)}
                                    />
                                </AccordionDetails>
                            </Accordion>
                            {/* group 5 */}
                            <Accordion>
                                <AccordionSummary>
                                    {Config.lang('Chu_ky1')}
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Attachment
                                        isStripDomain
                                        maxFile={1}
                                        accept={'image/*'}
                                        viewType={'picture'}
                                        readOnly={ViewMode || loading}
                                        domain={Config.getCDNPath()}
                                        data={dataOldSignature}
                                        style={{ minHeight: 160 }}
                                        onChange={(e) => this.onChangeAttachments(e, 1)}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        </AccordionGroup>
                    </Col>
                </Row>
            </PageContainer>
        )
    }
}

export default connect(state => ({
    anaMaster: state.w17f2051.anaMaster,
    cboGender: state.w17f2051.cboGender,
    cboCategoryType:state.w17f2051.cboCategoryType,
    anaMasterCation:state.w17f2051.anaMasterCation,
    formMaster:state.w17f2051.formMaster,
}),
(dispatch) => ({
    W17F2051Actions: bindActionCreators(W17F2051Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
    generalActions: bindActionCreators(generalActions, dispatch),
})
)(W17F2051Page);
